import Model, { attr, belongsTo } from '@ember-data/model';

export default class RegisterRedirectionToken extends Model {
  @attr('string') flowUserType;
  @attr('string') ownerEmail;
  @attr('string') partnerName;
  @attr('string') ownerFirstName;
  @attr('string') organizationName;
  @attr('string') organizationId;
  @attr('string') flowType;
  @attr('string') organizationLegalCountry;
  @attr('string') legalFlow;
  @attr('string') locale;
  @attr('string') partnerType;
  @attr('boolean') companyCreationFromScratch;

  @belongsTo('partner-registration', { polymorphic: true, async: true, inverse: null })
  partnerRegistration;

  get registrationID() {
    return this.belongsTo('partnerRegistration').id();
  }

  get isLegalPlace() {
    return this.partnerName?.toLowerCase() === 'legal-place';
  }

  get isEmbedded() {
    return this.partnerType === 'embed';
  }
}
